<template>
  <adset-budget-block
    ref="mainBlock"
    :entity="entity"
    :disabled="disabled"
  >
    <div class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Optimization goal') }}</ui-label>
      <p class="m-0 text-sm text-muted-foreground">{{ tr('It refers to the specific objective or outcome that you aim to achieve through your advertising campaign.') }}</p>
      <select-field
        v-model="entity.settings.adset_optimization_goal"
        :options="facebookAdsetOptimizationGoals"
        :reduce="(obj) => obj.machine_name"
        :placeholder="tr('Set an optimization goal')"
        :disabled="!entity.isNew || disabled"
      />
      <p class="m-0 text-sm text-muted-foreground">{{ tr('You will not be able to change this setting of this automation after the campaign has started.') }}</p>
    </div>

    <div v-if="!campaignHasBidStrategy" class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Bid strategy') }}</ui-label>
      <select-field
        v-model="entity.settings.adset_bid_strategy"
        :options="facebookAdsetBidStrategies"
        :reduce="(obj) => obj.machine_name"
        :aria-label="tr('Bid strategy')"
        :disabled="disabled"
      />
    </div>

    <div v-if="entity.bidAmountIsAvailable" class="flex flex-col gap-1.5">
      <ui-label>
        {{ bidAmountLabel }}
        <template v-if="!entity.bidAmountIsRequired">
          ({{ tr('optional') }})
        </template>
      </ui-label>
      <p v-if="!entity.isBidCapStrategy" class="m-0 text-sm text-muted-foreground">{{ tr('A type of advertising metric that is used to measure the effectiveness and efficiency of an advertising campaign. It represents the average cost that you pay for a specific result, such as a click, an impression, a lead, or a sale.') }}</p>
      <money-input
        v-model="entity.settings.adset_bid_amount"
        :currency="entity.adAccountCurrency.code"
        :disabled="disabled"
      />
      <info-text v-if="!entity.bidAmountIsRequired">
        {{ tr('Meta will aim to spend your entire budget and get the most link clicks using the highest volume bid strategy. If keeping the average cost per result around a certain amount is important, enter a cost per result goal.') }}
      </info-text>
    </div>
  </adset-budget-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import InfoText from '@/ui/components/InfoText.vue';
import MoneyInput from '@/ui/components/MoneyInput.vue';
import AdsetBudgetBlock from '@/ui/components/RuleForm/Blocks/AdsetBudgetBlock.vue';
import SelectField from '@/ui/components/SelectField.vue';

export default {
  name: 'AdsetBudgetNonOdaxBlock',
  components: {
    AdsetBudgetBlock,
    InfoText,
    MoneyInput,
    SelectField,
  },
  mixins: [ RuleFormBlockMixin ],
  computed: {
    facebookAdsetOptimizationGoals() {
      const items = this.$store.getters['app/facebookAdsetOptimizationGoals'];
      return this.$parent.filterSelectValuesByConditions(items);
    },
    facebookAdsetBidStrategies() {
      return this.$store.getters['app/facebookAdsetBidStrategies'];
    },
    facebookAdsetBillingEvents() {
      return this.$store.getters['app/facebookAdsetBillingEvents'];
    },
    campaignHasBidStrategy() {
      return this.entity.output_campaign.bid_strategy !== null;
    },
    bidAmountLabel() {
      return this.entity.isBidCapStrategy ? this.tr('Bid cap') : this.tr('Cost per result goal');
    },
  },
  created() {
    if (!this.entity.settings.adset_billing_event) {
      this.entity.settings.adset_billing_event = this.facebookAdsetBillingEvents[0].machine_name;
    }
  },
  methods: {
    validate() {
      return this.$refs.mainBlock.validate();
    },
  },
};
</script>
